import { handle } from 'src/shared-utilities/async-helpers/promise-helpers';
import { Borrower } from '../../../shared/models/deal-resources/borrower.model';
import { ClientJourneyContext } from '../../../shared/services/deal/client-journey-context';
import {
  DeleteResourceCommand,
  PostResourceCommand,
  ResourceCommand,
} from '../../../shared/services/resource-command-stream.service';
import { ValidationGlobalStore } from '../../../../../utilities/validation/validation-global-store';
import { ClientJourneyValidatorStoreBase } from '../../../shared/validation/client-journey-validator-store-base';
import { SlidesStateNames } from '../../../router/slides-states';
import { MortgageRequestValidator } from './mortgage-request.validator';
import { MortgageRequest } from '../../../shared/models/deal-resources/mortgage-request.model';
import { RealtorContactValidator } from './realtor-contact.validator';
import { Contact } from '../../../shared/models/deal-resources/contact.model';

export class GettingStartedValidatorStore extends ClientJourneyValidatorStoreBase {
  static readonly globalStoreKey = 'GettingStartedValidationStore';

  constructor(
    globalStore: ValidationGlobalStore,
    clientJourneyContext: ClientJourneyContext,
  ) {
    super(globalStore, clientJourneyContext, SlidesStateNames.GettingStarted);

    // Create a mortgage request validator
    this.getMortgageRequestValidator;

    // Create a realtor contact validator
    this.getRealtorContactValidator;
  }

  override dispose() {
    super.dispose();
  }

  private getMortgageRequestKey(mortgageRequest: MortgageRequest): string {
    let key = `mortgageRequest_${mortgageRequest.id}`;
    return key;
  }

  private getContactKey(contact: Contact): string {
    let key = `contact_${contact.id}`;
    return key;
  }

  getMortgageRequestValidator(
    mortgageRequest: MortgageRequest,
  ): MortgageRequestValidator {
    let key = this.getMortgageRequestKey(mortgageRequest);
    let validator = this.getValidator(key);
    if (!validator) {
      validator = new MortgageRequestValidator(
        mortgageRequest,
        this.clientJourneyContext,
      );
      this.addValidator(key, validator);
    }
    return validator as MortgageRequestValidator;
  }

  getRealtorContactValidator(contact: Contact): RealtorContactValidator {
    let key = this.getContactKey(contact);
    let validator = this.getValidator(key);
    if (!validator) {
      validator = new RealtorContactValidator(contact);
      this.addValidator(key, validator);
    }
    return validator as RealtorContactValidator;
  }
}
